import CaseSocReview from './CaseSocReview';

export default CaseSocReview;
export { CaseSocReview };
